<template>
    <div id="submitQ">
        <div class="line" v-if="isLine">
            <label>号码：</label>
            <div><span>{{ recordLoginText }}</span></div>
        </div>
        <div class="line" v-else>
            <label>号码：</label>
            <div><input type="text" placeholder="请输入" v-model="text" style="border:1px solid #ccc;box-sizing:border-box;padding:0 10px;"></div>
        </div>
        <div class="line">
            <label>问题描述：</label>
            <div class="moreInfo">
                <textarea v-model="data.problemContent" rows="4"></textarea>  
            </div>                    
        </div>
        <div>
            <mt-button type="primary" size="large" @click="submitFeedbackHandler">提交</mt-button>
        </div>
    </div>
</template>
<script>
import {submitFeedback, wxRequest} from '@/api/user'
export default {
    data(){
        return {
            data: {
                iccid: this.$store.state.iccid,
                problemContent: ''                
            },
            recordLoginText: localStorage.getItem('recordLoginText'),
            isLine: sessionStorage.getItem('isLine'), //判断是否登录进来还是链接进来
            text: ''
        }
    },
    methods: {
        submitFeedbackHandler(){
            if(this.isLine){
                var data = this.data;
            }else {
                sessionStorage.setItem('lineComplaintText', this.text);
                var data = {
                    iccid: this.text,
                    problemContent: this.data.problemContent
                }
            }
            wxRequest("userProblem/add", data, "post").then(res => {
                if(res.data.code == 200){
                    this.$toast({
                        message: '提交成功',
                        position: 'middle',
                        duration: 1500
                    })
                    this.data.problemContent = '';
                }else{
                    this.$toast({
                        message: res.data.message,
                        position: 'middle',
                        duration: 1500
                    })
                }
            })
        }
    }
}
</script>
<style lang="less">
#submitQ {
    margin-top: 10px;
    height: calc(100% - 40px);
    padding: 20px 4%;
    background: #fff;
}
</style>
